module.exports = __webpack_public_path__ + "static/media/webdesign-services-img69.42c02bc6.jpg";